import { API } from "aws-amplify";

export async function delOverrideZoneSchedule(companyId: string): Promise<void> {
  try {
    const path: string = `/geofence/override?companyId=${companyId}`;
    await API.del('api-service', path, {});
  } catch (error) {
    console.log(error);
    throw error;
  }
}